/**
 * Remove some things from a path for comparison with Contentful Pages.
 */
export const getComparablePath = (path: string): string =>
  path
    .replace(/[#?]{1}.*$/g, '') // Trim param `?…` and anchor `#…` from the comparePath; they aren't really a part of the path.
    .replace(/^\//, '') // remove starting slash
    .replace(/\/$/, '') // remove trailing slash
    .replace(/\.html$/, ''); // remove .html
